import React from 'react';
import ReactPlayer from 'react-player';
import {isMobile} from 'mobile-device-detect';
import FocusLock from 'react-focus-lock';

const VideoModal = props => (
    props.display ? <FocusLock autoFocus={true}><div style={{display: props.display}} className="video-modal-container">

        {!isMobile && <ReactPlayer width={`85%`} height={`74%`} url={props.data.video} controls className="video-player" />}
        {isMobile && <ReactPlayer youtubeConfig={{playerVars: {showinfo: false}}} width={Math.abs(window.orientation) === 90 ? `75%` : `100%`}
            height={Math.abs(window.orientation) === 90 ? `75%` : `35%`} url={props.data.video} controls className="video-player" />}
        <img src={`/images/exit.svg`} alt="Close Modal Button" tabIndex="0"
            onKeyDown={event => {
                if (event.keyCode === 13) {
                    props.closeModal(`ArticleClose`);
                } else if (event.keyCode === 32) {
                    props.closeModal(`ArticleClose`);
                }
            }}

            onClick={() => props.closeModal(`ArticleClose`)}/>
        <div className="hover-overlay"></div>

    </div></FocusLock> : null
);
export default VideoModal;
